import { AlkLogger } from '@alk/core';
import { COMMUNICATION_SERVICE, ICommunicationService } from '../../communication';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { inject, injectable } from 'inversify';
import { IResolvedTenor, ISessionDisposable, ITenorRequest } from '../../../interfaces';
import { ITenorResolveAdapterService } from './tenor-resolve-adapter.interface';
import { MessageTypes } from 'sfx-web-contract';
import { Observable, Subject } from 'rxjs';
import { pluckTyped } from '../../../helpers';
import { tenorResolveDecode, tenorResolveEncode } from './tenor-resolve-adapter.utils';

@injectable()
export class TenorResolveAdapterService implements ITenorResolveAdapterService, ISessionDisposable {

    @inject(COMMUNICATION_SERVICE) private readonly communicationService: ICommunicationService;

    private listOfRequestId: Array<number> = [];
    private readonly onDestroy$: Subject<boolean> = new Subject<boolean>();

    stop(): void {
        this.listOfRequestId = [];
        this.onDestroy$.next(true);
    }

    create(tenors: Array<ITenorRequest>): number {
        const requestId = this.communicationService
            .create(
                tenorResolveEncode(tenors),
                MessageTypes.TenorResolve,
            );

        this.listOfRequestId = [ ...this.listOfRequestId, requestId ];

        AlkLogger.debug([
            `[TenorResolveAdapterService#create] created`,
            `subscription for: ${ JSON.stringify(tenors) }`,
            `with request ID ${ requestId }}`,
        ].join(' '));

        return requestId;
    }

    remove(requestId: number): void {
        this.listOfRequestId = this.listOfRequestId.filter(id => id !== requestId);
        this.communicationService.delete(requestId);
    }

    resolvedTenorObservable(): Observable<Array<IResolvedTenor>> {
        return this.communicationService.dataObservable(MessageTypes.TenorResolve)
            .pipe(
                takeUntil(this.onDestroy$),
                filter(response => this.listOfRequestId.includes(response.communicationToken)),
                pluckTyped('payload'),
                map(tenorResolveDecode),
                tap(data => AlkLogger.debug(`[TenorResolveAdapterService#resolvedTenorObservable] received: ${ JSON.stringify(data) }`)),
            );
    }
}
